// X195 (Grant 2026-10-27: "The 'X available' under each date make it look really busy when it ellipsises"): the day
// buttons of the booking week strip (/book and the admin calendar) show a small availability bar under the date
// instead of words, colour AND fill so it is never colour alone, the exact count in the tooltip and label:
//   plenty           success, full bar
//   getting busy     warning, a third of the bar: at most METER_FEW_MAX left, or at most METER_FEW_SHARE of the day's
//   fully booked     error (Grant: "Use the Error color from vuetify"), the empty outline
//   closed all day   no bar, the word "Closed" in grey
//   anything else    nothing (open play all day, no hours, past days, days not open yet)
export const METER_FEW_MAX = 3;
export const METER_FEW_SHARE = 0.25;

/**
 * The day's meter from its strip entry: free (cells left to book, null when unknown), total (every bookable cell of
 * the day, booked or free), the strip's zero word ("Full", "Closed", "Open play", ...), past and beyond (not open yet).
 * Returns {level: 'plenty'|'few'|'full'|'closed', bar, fill (0..1), word?} or null for nothing.
 */
export function dayMeter({free = null, total = 0, word = '', past = false, beyond = false} = {}) {
  if (past || beyond || free == null) return null;
  if (free > 0) {
    const few = free <= METER_FEW_MAX || (total > 0 && free <= total * METER_FEW_SHARE);
    return few ? {level: 'few', bar: true, fill: 1 / 3} : {level: 'plenty', bar: true, fill: 1};
  }
  if (word === 'Closed') return {level: 'closed', bar: false, fill: 0, word: 'Closed'};
  if (word === 'Full') return {level: 'full', bar: true, fill: 0};
  return null;
}

/** The meter's words for the tooltip and label: "12 slots available", "1 slot available", "Fully booked", "Closed". */
export function meterWords(meter, free) {
  if (!meter) return '';
  if (meter.level === 'full') return 'Fully booked';
  if (meter.level === 'closed') return 'Closed';
  return `${free} ${free === 1 ? 'slot' : 'slots'} available`;
}
